(function() {
    window.c24LpInitializeFixables = function(parent) {

        if (!parent) {
            parent = 'body';
        }

        const fnVisiblityHandler = function(sFadeOutTriggerPrefix, sFadeOutTrigger, $fixable, iTriggerOffset, sMode = 'all') {

            const $fadeOutTrigger = document.querySelector(sFadeOutTriggerPrefix + sFadeOutTrigger);

            if ($(window).scrollTop() > iTriggerOffset) {
                if ($fadeOutTrigger) {
                    if (sMode === 'partially' || sMode === 'all') {
                        // only when sSelector is partially visible
                        const iPosition = $fadeOutTrigger.getBoundingClientRect();
                        if (iPosition.top < window.innerHeight && iPosition.bottom >= 0) {
                            if (!$fixable.hasClass('js24TmpHidden')) {
                                $fixable.stop().fadeOut({
                                    duration: 500,
                                    easing: 'swing',
                                }).addClass('js24TmpHidden');
                            }
                        } else {
                            if ($fixable.hasClass('js24TmpHidden')) {
                                $fixable.stop().fadeIn({
                                    duration: 500,
                                    easing: 'swing',
                                }).removeClass('js24TmpHidden');
                            }
                        }
                    }
                }

                if (!$fixable.hasClass('js24Fixed') && !$fixable.hasClass('js24TmpHidden')) {
                    $fixable.clone().addClass('js24FixableClone').appendTo($fixable.parent());
                    $fixable.addClass('js24Fixed').hide().stop().fadeIn({
                        duration: 500,
                        easing: 'swing',
                    });
                }
            } else {
                if ($fixable.hasClass('js24Fixed')) {
                    $('.js24FixableClone', $fixable.parent()).remove();
                    $fixable.removeClass('js24Fixed');
                }
            }
        };

        $('.js24Fixable .js24FixableTrigger', parent).each(function(_, element) {
            const triggerElement = $(element);

            if (parent === 'body' && triggerElement.closest('.vue').length) {
                return;
            }

            const sFadeOutTrigger = triggerElement.closest('.js24Fixable').data('fade-out');
            let triggerOffset = triggerElement.offset().top + triggerElement.outerHeight(true);
            let sFadeOutTriggerPrefix = '';

            if ($('.' + sFadeOutTrigger).length > 0) {
            // class
                sFadeOutTriggerPrefix = '.';
            } else if ($('#' + sFadeOutTrigger).length > 0) {
            // id
                sFadeOutTriggerPrefix = '#';
            }

            if (window.c24Lp.isIos() && triggerElement.hasClass('noios')) {
                return;
            }

            if (triggerElement.is(':visible') && $(window).scrollTop() > triggerOffset) {
                triggerElement.closest('.js24Fixable').addClass('js24Fixed').hide().stop().fadeIn({
                    duration: 500,
                    easing: 'swing',
                });
            }

            $(window).scroll(function() {
                const fixable = triggerElement.closest('.js24Fixable');
                if (!triggerElement.is(':visible') && !fixable.hasClass('js24TmpHidden')) {
                    return;
                }

                if (!fixable.hasClass('js24Fixed')) {
                    triggerOffset = triggerElement.offset().top + triggerElement.outerHeight(true);
                }

                fnVisiblityHandler(sFadeOutTriggerPrefix, sFadeOutTrigger, fixable, triggerOffset);
            });
        });
    };

    $(document).ready(function() {
        window.c24LpInitializeFixables();
    });
})();
